import keys from '@debbie/common/dist/cache/keys.js';
import { casesEntity, useCase } from '@debbie/cortex/dist/cases/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useMe } from '@debbie/cortex/dist/me/index.js';
import q from '@debbie/cortex/dist/query.js';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import deletedImage from '../../assets/images/deleted_image.svg';
import THEME from '../../theme.js';
import CaseInfo from '../CaseInfo/index.js';
import CasePauseStatus from '../CasePauseStatus/index.js';
import CaseHistory from '../Hist/CaseHistory.js';
import { PlaceholderLoader } from '../index.js';
import Panel from '../Panel.js';
import Tooltip from '../Tooltip.js';
const CasePreview = (props) => {
    const meLoadable = useMe();
    const me = h.hasData(meLoadable) ? meLoadable.data : null;
    const lang = useSelector((r) => r.lang);
    const [hovered, setHovered] = useState(false);
    const singleCaseLoader = useCase(hovered || props.seqId == null ? props.caseId : null);
    const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null;
    const [isTooltipMounted, setIsTooltipMounted] = useState(false);
    const [showTooltipOnTop, setShowTooltipOnTop] = useState(false);
    const ref = useRef(null);
    const id = props.caseId;
    const onMouseIn = () => {
        setHovered(true);
    };
    const onMouseOut = () => {
        setHovered(false);
    };
    // Refresh a cached case when the tooltip opens. When the hover itself
    // started the load there is nothing cached yet, and a refresh would only
    // queue a second request behind the first.
    useEffect(() => {
        if (isTooltipMounted && singleCase != null) {
            q.invalidate(keys.write.modify(casesEntity, props.caseId));
        }
    }, [isTooltipMounted]);
    return (React.createElement("div", { onMouseEnter: onMouseIn, onMouseLeave: onMouseOut, onClick: (e) => {
            e.stopPropagation();
            e.preventDefault();
        }, style: {
            position: 'relative',
            display: 'inline-block',
        } },
        React.createElement(CasePreviewStyled, { ref: ref, open: hovered && !props.noTooltip, showTooltipOnTop: showTooltipOnTop }, React.createElement(Link, { to: `/cases/${id}` },
            React.createElement("div", { className: "case-id", style: { display: 'flex' } },
                React.createElement("div", { className: "case-hash" }, "#"),
                singleCase?.id ?? props.seqId))),
        hovered && !props.noTooltip && me && (React.createElement(Tooltip, { tooltipToLeft: props.tooltipToLeft, parentRef: ref, setShowTooltipOnTop: setShowTooltipOnTop, shouldShowOnTop: showTooltipOnTop, setIsMounted: setIsTooltipMounted }, singleCase ? (singleCase.deleted ? (React.createElement("div", { style: {
                display: 'block',
                margin: '80px auto',
                width: '60%',
            } },
            React.createElement("img", { style: {
                    width: '100%',
                }, src: deletedImage }),
            React.createElement("h1", null, lang.cases.caseHasBeenDeleted))) : (React.createElement(React.Fragment, null,
            React.createElement(CasePauseStatus, { case: singleCase }),
            React.createElement(Panel, null,
                React.createElement(CaseInfo, { caseId: singleCase.caseId })),
            React.createElement("br", null),
            React.createElement(CaseHistory, { caseId: singleCase.caseId })))) : (React.createElement(PlaceholderLoader, null))))));
};
export default CasePreview;
const CasePreviewStyled = styled.div `
  display: inline-block;
  background: ${THEME.FILL};
  padding: 0.2em 0.6em 0.2em 0.2em;
  border-radius: 1em;
  font-weight: 300;
  position: relative;

  ${(props) => props.open
    ? props.showTooltipOnTop
        ? `
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  `
        : `
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
`
    : ''} &:hover {
    opacity: 0.8;
  }

  div.case-hash {
    font-style: italic;
    display: inline-block;
    opacity: 0.7;
    font-weight: 900;
    margin-right: 0.3em;
    height: 1.3em;
    width: 1.3em;
    background-color: #bdbdbd;
    border-radius: 100%;
    padding: 0.05em 0.1em 0em 0em;
    text-align: center;
  }

  a {
    text-decoration: none;
    color: inherit;
  }
`;
//# sourceMappingURL=CasePreview.js.map